<template>
  <apexchart
    type="bar"
    :options="columnChart.options"
    :series="columnChart.series"
  ></apexchart>
</template>

<script>
export default {
  data() {
    return {
      columnChart: {
        options: {
          chart: {
            // height: 300,
            type: "bar",
          },
          // title: {
          //   text: "Profit & Margin Chart",
          //   align: "center",
          // },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "80%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["red", "#8753de", "#b6c2c9"],
          xaxis: {
            categories: [
              "Johor",
              "Kedah",
              "Kelantan",
              "Negeri Sembilan",
              "Pahang",
              "Perak",
              "Pulau Pinang",
              "Sarawak",
              "Selangor",
              "Terengganu",
            ],
            axisBorder: {
              show: true,
              color: "rgba(182, 194, 201, 0.5)",
              height: 1,
              width: "100%",
              offsetX: 0,
              offsetY: -1,
            },
            axisTicks: {
              show: true,
              borderType: "solid",
              color: "#b6c2c9",
              height: 6,
              offsetX: 0,
              offsetY: 0,
            },
          },
          yaxis: {
            // title: {
            //   text: "$ (thousands)",
            // },
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              // formatter: function (val) {
              //   return "$ " + val + " thousands";
              // },
            },
          },
        },
        series: [
          {
            name: "Lelaki",
            data: [149, 129, 173, 109, 113, 234, 39, 99, 285, 113],
          },
          {
            name: "Wanita",
            data: [45, 20, 23, 29, 32, 81, 7, 23, 48, 17],
          },
        ],
      },
    };
  },
};
</script>
